import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Tooltip } from "react-tooltip";
import { toast } from 'react-toastify';
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitChatTemplate } from "../../../../utils/chatApi";

//Import Widgets
import CommonTemplate from "../../../../components/Apps/AIChatBot/Template/CommonTemplate";

//Import Tabs
import TraningTab from "../../../../components/Apps/AIChatBot/TraningTab";
import GreetingTab from "../../../../components/Apps/AIChatBot/GreetingTab";
import GeneralTab from "../../../../components/Apps/AIChatBot/GeneralTab";
import ThemeTab from "../../../../components/Apps/AIChatBot/ThemeTab";

export default function CreateAIChatBot() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Traning");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Virtual_Assistant_Temp");
    const [selectedLayout, setSelectedLayout] = useState("virtual_assistant_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("virtual-assistant.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled AI ChatBot");
    const [newWidgetName, setNewWidgetName] = useState("");

    const [chatTabData, setChatTabData] = useState({
        is_website_frontend: "", 
        is_collect_user_details: 1, 
        is_follow_up_message: 1, 
        follow_up_message_text: 'Did I help resolve your issue? If you need further assistance, feel free to ask!', 
        assistant_instructions_text: `Respond on behalf of the business as an employee. Use an appropriate tone.

Keep your answers informative yet concise. Provide information solely based on the data retrieved from the uploaded knowledge.
If the information is unavailable, inform the user that you cannot assist and recommend contacting the business directly.

Always prioritize searching for information in the provided knowledge base before suggesting direct contact with the company.
Responses should be based exclusively on the data found in the knowledge base.

Business Name: Cloudflare
Business Industry: Internet Security
Business Overview: Cloudflare provides internet security and performance services, protecting websites from online threats and ensuring fast, reliable access for users worldwide.

Assistant's Role: Customer Support Agent

Contact Details:`,    
        chat_window_picture: "",  
        chat_window_name: "",  
        welcome_message: "",     
        display_type: "chat-window-only",  
        is_send_chat_history_to_email: 1, 
        owner_email: "",  
        theme_type: "",           
        font_type: "",  
        accent_color: "",   
        chat_triggers_is_on_page_load: 1,    
        is_show_bubble_notification_badge: 1,    
        custom_css:  "",  
        custom_js: "",  
    });

    // Set Template Setting And Texts when activeTemplateSection changes
    useEffect(() => {
        let theme_type = ""; 
        let chat_window_name = "";  
        let accent_color = "";  
        let welcome_message = "";
    
        switch (activeTemplateSection) {
            case "Virtual_Assistant_Temp":
                theme_type = "theme-1";  
                chat_window_name = "Virtual Assistant";  
                accent_color = "#F93262";
                welcome_message = 'Welcome to Cloudflare! How can I assist you today?';
                break;
            case "Virtual_Assistant_Temp2":
                theme_type = "theme-2";  
                chat_window_name = "Virtual Assistant";  
                accent_color = "#F93262";
                welcome_message = "Welcome to Cloudflare! How can I assist you today?";
                break;
            case "Virtual_Assistant_Temp3":
                theme_type = "theme-3";  
                chat_window_name = "Virtual Assistant";  
                accent_color = "#F93262";
                welcome_message = "Welcome to Cloudflare! How can I assist you today?";
                break;
            case "Virtual_Assistant_Temp4":
                theme_type = "theme-4";  
                chat_window_name = "Virtual Assistant";  
                accent_color = "#F93262";
                welcome_message = "Welcome to Cloudflare! How can I assist you today?";
                break;
            case "Virtual_Assistant_Temp5":
                theme_type = "theme-5";  
                chat_window_name = "Virtual Assistant"; 
                accent_color = "#F93262"; 
                welcome_message = "Welcome to Cloudflare! How can I assist you today?";
                break;
            case "Dark_Theme_Temp":
                theme_type = "theme-6";  
                chat_window_name = "Virtual Assistant";  
                accent_color = "#F93262";
                welcome_message = "Welcome to Cloudflare! How can I assist you today?";
                break;
            default:
                theme_type = "";  
                chat_window_name = "";  
                accent_color = "";
                welcome_message = "";
        }
    
        // Update setChatTabData state with the data
        setChatTabData((prevData) => ({
            ...prevData,
            theme_type: theme_type,
            chat_window_name: chat_window_name,
            accent_color: accent_color,
            welcome_message: welcome_message,
        }));
    
    }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateChatTabData = (key, value) => {
        setChatTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = () => {
        setShowTemplateSelection(false);
        setIsSubmitting(false);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            setSelectedLayout(layoutTypeValue);
        } else {
            alert('Please select a template');
        }
    }; 

    const menuItems = [
        { key: "Traning", icon: "traning.png", label: "Traning" },
        { key: "Greeting", icon: "greeting.png", label: "Greeting" },
        { key: "General", icon: "general.png", label: "General" },
        { key: "Theme", icon: "theme.png", label: "Theme" },
    ];

    // Handle Source Tab input change
    const handleActiveTemplateInputChange = (event) => {
        setActiveTemplateSection(event.target.value);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            const template_image = selectedRadio.dataset.template_image;
            setSelectedLayout(layoutTypeValue);
            setSelectedTemplateImage(template_image);
        } else {
            alert('Please select a template');
        }
    };

    //Submit Form data
    const submitForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const formData = new FormData();

            // Append text fields
            formData.append("name", widgetName);
            formData.append("template_name", activeTemplateSection);
            formData.append("template_image", selectedTemplateImage);
            formData.append("layout_name", selectedLayout);
            formData.append("layout_type", selectedLayout);
            formData.append("app_type", "AI_ChatBot");
    
            // Append settings as JSON string
            formData.append(
                "settings",
                JSON.stringify(
                    Object.entries(chatTabData).map(([key, value]) => ({
                        setting_key: key,
                        setting_value: value,
                    }))
                )
            );

            // Check if chat_window_picture is a File and append it
            if (chatTabData.chat_window_picture) {
                // If it's a File object (newly uploaded), append it directly
                if (chatTabData.chat_window_picture instanceof File) {
                    formData.append("chat_window_picture", chatTabData.chat_window_picture);
                } 
                // If it's a string (from predefined template), just send the image file name
                else if (typeof chatTabData.chat_window_picture === 'string') {
                    const imageName = chatTabData.chat_window_picture.split('/').pop();
                    formData.append("chat_window_picture", imageName);
                }
            }

            //Api Call
            let api_response = await submitChatTemplate(formData);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/ai-chatbot');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
          <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="AI ChatBot" app_type="AI_ChatBot" app_slug="ai-chatbot"/>
                {showTemplateSelection ? (
                    <div className="create-goole-reviews-side">
                        <span>Select a template to start with</span>
                        <div className="card h-100">
                            <div className="label-box-flex">
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="Virtual_Assistant_Temp" data-layout_type="virtual_assistant_layout" data-template_image="virtual-assistant.png" checked={activeTemplateSection === "Virtual_Assistant_Temp"} onChange={handleActiveTemplateInputChange} />
                                    <div className="card card-body">
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/ai-chatbot/templates/virtual-assistant.png`} alt="virtual-assistant" />
                                        </div>
                                        <div className="content_sub">Virtual Assistant</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="Virtual_Assistant_Temp2" data-layout_type="virtual_assistant_layout2" data-template_image="virtual-assistant2.png" checked={activeTemplateSection === "Virtual_Assistant_Temp2"} onChange={handleActiveTemplateInputChange} />
                                    <div className="card card-body">
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/ai-chatbot/templates/virtual-assistant2.png`} alt="virtual-assistant2" />
                                        </div>
                                        <div className="content_sub">Virtual Assistant 2</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="Virtual_Assistant_Temp3" data-layout_type="virtual_assistant_layout3" data-template_image="virtual-assistant3.png" checked={activeTemplateSection === "Virtual_Assistant_Temp3"} onChange={handleActiveTemplateInputChange} />
                                    <div className="card card-body">
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/ai-chatbot/templates/virtual-assistant3.png`} alt="virtual-assistant3" />
                                        </div>
                                        <div className="content_sub">Virtual Assistant 3</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="Virtual_Assistant_Temp4" data-layout_type="virtual_assistant_layout4" data-template_image="virtual-assistant4.png" checked={activeTemplateSection === "Virtual_Assistant_Temp4"} onChange={handleActiveTemplateInputChange} />
                                    <div className="card card-body">
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/ai-chatbot/templates/virtual-assistant4.png`} alt="virtual-assistant4" />
                                        </div>
                                        <div className="content_sub">Virtual Assistant 4</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="Virtual_Assistant_Temp5" data-layout_type="virtual_assistant_layout5" data-template_image="virtual-assistant5.png" checked={activeTemplateSection === "Virtual_Assistant_Temp5"} onChange={handleActiveTemplateInputChange} />
                                    <div className="card card-body">
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/ai-chatbot/templates/virtual-assistant5.png`} alt="virtual-assistant5" />
                                        </div>
                                        <div className="content_sub">Virtual Assistant 5</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="Dark_Theme_Temp" data-layout_type="dark_theme_layout" data-template_image="dark-theme.png" checked={activeTemplateSection === "Dark_Theme_Temp"} onChange={handleActiveTemplateInputChange} />
                                    <div className='card card-body'>
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/ai-chatbot/templates/dark-theme.png`} alt="dark-theme" />
                                        </div>
                                        <div className="content_sub">Virtual Assistant Dark Theme</div>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div className="continue-template">
                            <button onClick={handleContinueTemplate}>Continue with this template</button>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="overlay-side-baar">
                            <div className="side-baar-inner-one">
                                <ul>
                                    {menuItems.map((item) => (
                                        <li key={item.key}>
                                            <button
                                                className={activeSection === item.key ? "active" : ""}
                                                onClick={() => setActiveSection(item.key)}
                                            >
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/ai-chatbot/icons//${item.icon}`}
                                                    alt={`${item.key} icon`}
                                                />
                                                <span>{item.label}</span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="side-baar-inner-tow">
                                {/* Conditional Rendering for Sections */}
                                {activeSection === "Traning" && (
                                  <TraningTab updateChatTabData={updateChatTabData} chatTabData={chatTabData}/>
                                )}
                                
                                {activeSection === "Greeting" && (
                                  <GreetingTab updateChatTabData={updateChatTabData} chatTabData={chatTabData}/>
                                )}

                                {activeSection === "General" && (
                                  <GeneralTab updateChatTabData={updateChatTabData} chatTabData={chatTabData}/>
                                )}

                                {activeSection === "Theme" && (
                                  <ThemeTab updateChatTabData={updateChatTabData} chatTabData={chatTabData}/>
                                )}
                            </div>
                        </div>
                    </>
                )}
                <div className="create-goole-reviews-right">
                    <div className="content-wrapper">
                        <div className="source-header-row">
                            <h2><Link to="/customer/apps/ai-chatbot"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                            <div className="untitled-widget-name whtsapp-icon">
                                <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/images/app-icon/ai-chatbot.svg`} alt="ai-chatbot"/>{ widgetName }</button>
                                <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                            </div>
                            <div className='submit-google-review'>
                              <button type="button" onClick={submitForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                              <Link to="/customer/apps/ai-chatbot/pricing/single" className="view-plan">View Plans</Link>
                              <Link to="/customer/apps/ai-chatbot" className="close-button">Close</Link></div>
                        </div>
                        <div className="source-title-row">AI ChatBot <img src={`${process.env.PUBLIC_URL}/images/icon-24.png`} alt="icon-24" /> <strong>Connect</strong></div>

                        {/*Call Common template*/}
                        <CommonTemplate selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} chatTabData={chatTabData} /> 
                    </div>
                </div>
            </div>

            {/* Rename Popup */}
            {renameWidgetNameModel && (
                <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                    <div className="bg-white p-3 rounded-lg shadow-lg">
                        <h3 className="text-lg font-semibold">Rename Widget</h3>
                        <label>Widget Name</label>
                        <input
                            type="text"
                            className="border p-2 w-full mt-2"
                            value={newWidgetName}
                            onChange={(e) => setNewWidgetName(e.target.value)}
                        />
                        <div className="mt-3 flex justify-end">
                            <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                                Cancel
                            </button>
                            <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
      );
}
